import { CommonModule } from '@angular/common';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { AlertService } from '../services/alert/alert.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SafeHtmlPipe } from '../helpers/pipes/safe-html/safe-html.pipe';
import { INTERVAL_DELAY } from '../helpers/var/common';


@Component({
  selector: 'app-alert',
  standalone: true,
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css',
  imports: [CommonModule, MatTooltipModule, SafeHtmlPipe]
})
export class AlertComponent
{
  @ViewChild('carouselEl') carouselEl!: ElementRef
  eventBound = false
  date:string = new Date().toISOString().slice(0,10)
  nb_alertes:number = 0
  nb_informations:number = 0
  nb_interruptions:number = 0
  isCarouselVisible:boolean = true
  isCarouselContainerVisible:boolean = false
  slides:{contenu:string, type_alerte:string}[] = []
  bgColor!:string
  textColor:string = "black"
  content!:string

  constructor
  (
    private alertService: AlertService,
    private renderer: Renderer2
  ) {}

  ngOnInit()
  {
    this.getAlertesInterval()
  }

  getAlertesInterval()
  {
    this.getAlertes()

    setInterval(() => {
      this.getAlertes()
    }, INTERVAL_DELAY)
  }

  ngAfterViewChecked(): void 
  {
    if (this.carouselEl && !this.eventBound) 
    {
      document.addEventListener('slide.bs.carousel', (event: any) => {
        const nextSlide = event.relatedTarget
        const classList = nextSlide.className

        if (classList.includes('alerte')) 
        {
          this.removeBgClasses() 
          this.addClassToCarousel("bg-red")
        } 
        else if (classList.includes('warning')) 
        {
          this.removeBgClasses() 
          this.addClassToCarousel("bg-orange")
        } 
        else if (classList.includes('interrupt')) 
        {
          this.removeBgClasses() 
          this.addClassToCarousel("bg-dark")
        } 
        else 
        {
          this.removeBgClasses() 
          this.addClassToCarousel("bg-red")
        }
      })

      this.eventBound = true
    }
  }

  formatDate(date:Date)
  {
    return date.toString().slice(0,10)
  }

  addClassToCarousel(className: string) 
  {
    if (this.carouselEl) 
    {
      this.renderer.addClass(this.carouselEl.nativeElement, className)
    }
  }

  removeBgClasses() 
  {
    const bgClasses = ['bg-red', 'bg-orange', 'bg-dark']
    for (const cls of bgClasses) 
    {
      this.renderer.removeClass(this.carouselEl.nativeElement, cls)
    }
  }

  getAlertes()
  {
    this.alertService.getData().subscribe(data => {
      if(!data || (Array.isArray(data) && data.length == 0))
      {
        this.isCarouselContainerVisible = false
        return
      }

      const filteredData = data.filter(e => this.formatDate(e.date_debut) <= this.date && this.formatDate(e.date_fin) >= this.date)

      this.nb_alertes = filteredData.filter(e => e.type_alerte == 'alerte').length
      this.nb_informations = filteredData.filter(e => e.type_alerte == 'warning').length
      this.nb_interruptions = filteredData.filter(e => e.type_alerte == 'interrupt').length
      
      if(this.nb_alertes > 0 || this.nb_informations > 0) this.isCarouselContainerVisible = true

      this.slides = filteredData.map( e => {
        return {type_alerte:e.type_alerte, contenu:e.contenu.replaceAll("&nbsp;"," ")}
      })
      
      switch (this.slides[0]?.type_alerte) 
      {
        case "alerte":
          this.bgColor = "bg-red"
          this.textColor = "red"
        break;
        case "warning":
          this.bgColor = "bg-orange"
          this.textColor = "orange"
        break;
        case "interrupt":
          this.bgColor = "bg-dark"
          this.textColor = "text-dark"
        break;
      }
    })
  }

  toggleAlert()
  {
    this.isCarouselVisible = !this.isCarouselVisible
  }
}
